import "./theme.css"
import ThemeHelpers from "../_helpers"
const configTheme = {
  initFireWork: () => {
    var canvas = ThemeHelpers.createCanvas()
    var ctx = canvas.getContext("2d")
    var // full screen dimensions
      cw = window.innerWidth,
      ch = window.innerHeight,
      // firework collection
      fireworks = [],
      // particle collection
      particles = [],
      // starting hue
      hue = 120,
      // when launching fireworks with a click, too many get launched at once without a limiter, one launch per 5 loop ticks
      limiterTotal = 5,
      limiterTick = 0,
      limiterFire = 5,
      // this will time the auto launches of fireworks, one launch per 80 loop ticks
      timerTotal = 80,
      timerTick = 0,
      timerFire = 0,
      sameFire = 30,
      mousedown = false,
      // mouse x coordinate,
      mx,
      // mouse y coordinate
      my

    canvas.width = cw
    canvas.height = ch
    function random(min, max) {
      return Math.random() * (max - min) + min
    }
    function calculateDistance(p1x, p1y, p2x, p2y) {
      var xDistance = p1x - p2x,
        yDistance = p1y - p2y
      return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2))
    }
    // create firework
    function Firework(sx, sy, tx, ty) {
      // actual coordinates
      this.x = sx
      this.y = sy
      // starting coordinates
      this.sx = sx
      this.sy = sy
      // target coordinates
      this.tx = tx
      this.ty = ty
      // distance from starting point to target
      this.distanceToTarget = calculateDistance(sx, sy, tx, ty)
      this.distanceTraveled = 0
      // track the past coordinates of each firework to create a trail effect, increase the coordinate count to create more prominent trails
      this.coordinates = []
      this.coordinateCount = 3
      // populate initial coordinate collection with the current coordinates
      while (this.coordinateCount--) {
        this.coordinates.push([this.x, this.y])
      }
      this.angle = Math.atan2(ty - sy, tx - sx)
      this.speed = 2
      this.acceleration = 1.05
      this.brightness = random(50, 70)
      // circle target indicator radius
      this.targetRadius = 1
    }

    // update firework
    Firework.prototype.update = function (index) {
      // remove last item in coordinates array
      this.coordinates.pop()
      // add current coordinates to the start of the array
      this.coordinates.unshift([this.x, this.y])

      // cycle the circle target indicator radius
      if (this.targetRadius < 8) {
        this.targetRadius += 0.3
      } else {
        this.targetRadius = 1
      }

      // speed up the firework
      this.speed *= this.acceleration

      // get the current velocities based on angle and speed
      var vx = Math.cos(this.angle) * this.speed,
        vy = Math.sin(this.angle) * this.speed
      // how far will the firework have traveled with velocities applied?
      this.distanceTraveled = calculateDistance(
        this.sx,
        this.sy,
        this.x + vx,
        this.y + vy
      )

      // if the distance traveled, including velocities, is greater than the initial distance to the target, then the target has been reached
      if (this.distanceTraveled >= this.distanceToTarget) {
        createParticles(this.tx, this.ty)
        // remove the firework, use the index passed into the update function to determine which to remove
        fireworks.splice(index, 1)
      } else {
        // target not reached, keep traveling
        this.x += vx
        this.y += vy
      }
    }

    // draw firework
    Firework.prototype.draw = function () {
      ctx.beginPath()
      // move to the last tracked coordinate in the set, then draw a line to the current x and y
      ctx.moveTo(
        this.coordinates[this.coordinates.length - 1][0],
        this.coordinates[this.coordinates.length - 1][1]
      )
      ctx.lineTo(this.x, this.y)
      ctx.strokeStyle = "hsl(" + hue + ", 100%, " + this.brightness + "%)"
      ctx.stroke()

      ctx.beginPath()
      // draw the target for this firework with a pulsing circle
      ctx.arc(this.tx, this.ty, this.targetRadius, 0, Math.PI * 2)
      ctx.stroke()
    }

    // create particle
    function Particle(x, y) {
      this.x = x
      this.y = y
      // track the past coordinates of each particle to create a trail effect, increase the coordinate count to create more prominent trails
      this.coordinates = []
      this.coordinateCount = 5
      while (this.coordinateCount--) {
        this.coordinates.push([this.x, this.y])
      }
      // set a random angle in all possible directions, in radians
      this.angle = random(0, Math.PI * 2)
      this.speed = random(1, 10)
      // friction will slow the particle down
      this.friction = 0.95
      // gravity will be applied and pull the particle down
      this.gravity = 1
      // set the hue to a random number +-50 of the overall hue variable
      this.hue = random(hue - 50, hue + 50)
      this.brightness = random(50, 80)
      this.alpha = 1
      // set how fast the particle fades out
      this.decay = random(0.015, 0.03)
    }

    // update particle
    Particle.prototype.update = function (index) {
      // remove last item in coordinates array
      this.coordinates.pop()
      // add current coordinates to the start of the array
      this.coordinates.unshift([this.x, this.y])
      // slow down the particle
      this.speed *= this.friction
      // apply velocity
      this.x += Math.cos(this.angle) * this.speed
      this.y += Math.sin(this.angle) * this.speed + this.gravity
      // fade out the particle
      this.alpha -= this.decay

      // remove the particle once the alpha is low enough, based on the passed in index
      if (this.alpha <= this.decay) {
        particles.splice(index, 1)
      }
    }

    // draw particle
    Particle.prototype.draw = function () {
      ctx.beginPath()
      // move to the last tracked coordinates in the set, then draw a line to the current x and y
      ctx.moveTo(
        this.coordinates[this.coordinates.length - 1][0],
        this.coordinates[this.coordinates.length - 1][1]
      )
      ctx.lineTo(this.x, this.y)
      ctx.strokeStyle =
        "hsla(" +
        this.hue +
        ", 100%, " +
        this.brightness +
        "%, " +
        this.alpha +
        ")"
      ctx.stroke()
    }

    // create particle group/explosion
    function createParticles(x, y) {
      // increase the particle count for a bigger explosion, beware of the canvas performance hit with the increased particles though
      var particleCount = 30
      while (particleCount--) {
        particles.push(new Particle(x, y))
      }
    }

    // main demo loop
    function loop() {
      // this function will run endlessly with requestAnimationFrame
      ThemeHelpers.runRequestAnimaion(loop)

      // increase the hue to get different colored fireworks over time
      //hue += 0.5;

      // create random color
      hue = random(0, 360)

      // normally, clearRect() would be used to clear the canvas
      // we want to create a trailing effect though
      // setting the composite operation to destination-out will allow us to clear the canvas at a specific opacity, rather than wiping it entirely
      ctx.globalCompositeOperation = "destination-out"
      // decrease the alpha property to create more prominent trails
      ctx.fillStyle = "rgba(0, 0, 0, 0.5)"
      ctx.fillRect(0, 0, cw, ch)
      // change the composite operation back to our main mode
      // lighter creates bright highlight points as the fireworks and particles overlap each other
      ctx.globalCompositeOperation = "lighter"

      // loop over each firework, draw it, update it
      var i = fireworks.length
      while (i--) {
        fireworks[i].draw()
        fireworks[i].update(i)
      }

      // loop over each particle, draw it, update it
      var j = particles.length
      while (j--) {
        particles[j].draw()
        particles[j].update(j)
      }

      // launch fireworks automatically to random coordinates, when the mouse isn't down
      if (timerTick >= timerTotal) {
        if (!mousedown && timerFire < limiterFire) {
          // start the firework at the bottom middle of the screen, then set the random target coordinates, the random y coordinates will be set within the range of the top half of the screen
          for (let i = 0; i < sameFire; i++) {
            fireworks.push(
              new Firework(cw / 2, ch, random(0, cw), random(0, ch / 2))
            )
          }
          timerFire++
          timerTick = 0
        }
      } else {
        timerTick++
      }
    }

    window.addEventListener("mousedown", function (e) {
      // console.log("mousedown:", e.clientX, e.x, e.pageX)
      fireworks.push(new Firework(cw / 2, ch, e.pageX, e.pageY))
      // fireworks.push(new Firework(cw / 2, ch, e.pageX + 10, e.pageY + 5))
      // fireworks.push(new Firework(cw / 2, ch, e.pageX - 5, e.pageY - 10))
    })
    setTimeout(() => {
      console.warn("Start")
      loop()
    }, 1000)
  },
  initHoaRoi: () => {
    var elem = document.body
    var isTabActive
    var imgLoaded
    var canvas = ThemeHelpers.createCanvas()
    var ctx = canvas.getContext("2d")
    var width = elem.clientWidth || window.innerWidth
    var height = elem.clientHeight || window.innerHeight
    console.warn("width:", width, height, elem)
    var active = false

    function onResize() {
      width = elem.clientWidth || window.innerWidth
      height = elem.clientHeight || window.innerHeight
      canvas.width = width
      canvas.height = height
      ctx.fillStyle = "#FFF"

      var wasActive = active
      active = width > 700

      if (!wasActive && active) {
        window.requestAnimationFrame(snow)
        // window.requestAnimFrame && window.requestAnimFrame(update)
      }
    }

    var flakes = [],
      flakeCount = 50,
      mX = -100,
      mY = -100

    function reset(flake) {
      flake.x = Math.floor(Math.random() * canvas.width)
      flake.y = 0
      flake.size = Math.random() * 16 + 12
      flake.speed = Math.random() * 1 + 0.5
      flake.velY = flake.speed
      flake.velX = 0
      flake.opacity = Math.random() * 0.5 + 0.3
      flake.lifetime = 0
      flake.flip = Math.random()
    }

    for (var i = 0; i < flakeCount; i++) {
      var x = Math.floor(Math.random() * width),
        y = Math.floor(Math.random() * height),
        size = Math.random() * 16 + 12,
        speed = Math.random() * 1 + 0.5,
        opacity = Math.random() * 0.5 + 0.3

      flakes.push({
        speed: speed,
        velY: speed,
        velX: 0,
        x: x,
        y: y,
        size: size,
        stepSize: Math.random() / 30,
        step: 0,
        opacity: opacity,
        lifetime: 0,
        flip: Math.random(),
      })
    }

    const petalImg = new Image()
    petalImg.src = "https://djjjk9bjm164h.cloudfront.net/petal.png"
    petalImg.addEventListener("load", () => {
      imgLoaded = true
    })
    var wind = 2

    function snow() {
      if (isTabActive == false || imgLoaded !== true) {
        return
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      for (var i = 0; i < flakeCount; i++) {
        var flake = flakes[i],
          x = mX,
          y = mY,
          minDist = 150,
          x2 = flake.x,
          y2 = flake.y

        var dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
          dx = x2 - x,
          dy = y2 - y

        if (dist < minDist) {
          var force = minDist / (dist * dist),
            xcomp = (x - x2) / dist,
            ycomp = (y - y2) / dist,
            deltaV = force / 2

          flake.velX -= deltaV * xcomp
          flake.velY -= deltaV * ycomp
        } else {
          flake.velX *= 0.98
          let _speed = flake.speed
          if (wind != 0) {
            _speed = _speed * Math.abs(wind)
          }
          if (flake.velY <= _speed) {
            flake.velY = _speed
          }
          var tX = Math.cos((flake.step += 0.05)) * flake.stepSize
          if (wind != 0) {
            flake.velX += Math.abs(tX) * wind * 5
          } else {
            flake.velX += tX
          }
        }

        ctx.fillStyle = "rgba(255, 183, 197," + flake.opacity + ")"
        flake.y += flake.velY
        flake.x += flake.velX
        // console.warn("x,y:", flake.x, flake.y)

        if (flake.y >= canvas.height || flake.y <= 0) {
          reset(flake)
        }

        if (flake.x >= canvas.width || flake.x <= 0) {
          reset(flake)
        }

        flake.lifetime++
        ctx.globalAlpha = flake.opacity

        ctx.beginPath()
        // ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2)
        ctx.drawImage(
          petalImg,
          flake.x,
          flake.y,
          flake.size * (0.6 + Math.abs(Math.cos(flake.lifetime / 100)) / 3),
          flake.size * (0.8 + Math.abs(Math.sin(flake.lifetime / 100)) / 5)
        )
        ctx.fill()
      }
      window.requestAnimationFrame(snow)
    }

    // shim layer with setTimeout fallback
    // window.requestAnimFrame = (function () {
    //   return (
    //     window.requestAnimationFrame ||
    //     window.webkitRequestAnimationFrame ||
    //     window.mozRequestAnimationFrame ||
    //     function (callback) {
    //       window.setTimeout(callback, 5000 / 60)
    //     }
    //   )
    // })()

    window.addEventListener("mousemove", function (e) {
      mX = e.clientX
      mY = e.clientY
    })

    onResize()
    window.addEventListener("resize", onResize, false)

    window.onfocus = function () {
      let _lastInactive = false
      if (isTabActive == false) {
        _lastInactive = true
      }
      isTabActive = true
      if (_lastInactive) {
        window.requestAnimationFrame(snow)
      }

      console.log("isTabActive:", isTabActive)
    }

    window.onblur = function () {
      isTabActive = false
      console.log("isTabActive:", isTabActive)
    }
  },
  init: () => {
    window.document.body.classList.add("theme-tet2024")
    if (document.getElementById("t-top") == null) {
      let elemDiv = document.createElement("div")
      elemDiv.className = "t-overlay"
      elemDiv.id = "t-top"
      elemDiv.style.background = "url(/css/themes/tet2024/2024b.png)"
      elemDiv.style.backgroundSize = "300px"
      elemDiv.style.backgroundRepeat = "no-repeat"
      elemDiv.style.backgroundPositionX = "80%"
      elemDiv.style.backgroundPositionY = "-200px"
      document.body.appendChild(elemDiv)
    }
    if (document.getElementById("t-topleft") == null) {
      let elemDiv = document.createElement("div")
      elemDiv.className = "t-overlay"
      elemDiv.id = "t-topleft"
      elemDiv.style.background = "url(/css/themes/tet2024/canhdao1.png)"
      elemDiv.style.backgroundSize = "360px"
      elemDiv.style.backgroundRepeat = "no-repeat"
      elemDiv.style.backgroundPositionX = "-10px"
      elemDiv.style.backgroundPositionY = "-190px"
      document.body.appendChild(elemDiv)
    }
    if (document.getElementById("t-topright") == null) {
      let elemDiv = document.createElement("div")
      elemDiv.className = "t-overlay"
      elemDiv.id = "t-topright"
      document.body.appendChild(elemDiv)
    }
    if (document.getElementById("t-topleft2") == null) {
      let elemDiv = document.createElement("div")
      elemDiv.className = "t-overlay"
      elemDiv.id = "t-topleft2"
      elemDiv.style.background = "url(/css/themes/tet2024/canhdao2.png)"
      elemDiv.style.backgroundSize = "300px"
      elemDiv.style.backgroundRepeat = "no-repeat"
      elemDiv.style.backgroundPosition = "bottom left"
      elemDiv.style.backgroundPositionY = "-70px"
      document.body.appendChild(elemDiv)
    }
    if (document.getElementById("t-topleft3") == null) {
      let elemDiv = document.createElement("div")
      elemDiv.className = "t-overlay"
      elemDiv.id = "t-topleft3"
      elemDiv.style.background = "url(/css/themes/tet2024/dao.png)"
      elemDiv.style.backgroundSize = "300px"
      elemDiv.style.backgroundRepeat = "no-repeat"
      elemDiv.style.backgroundPosition = "bottom left"
      elemDiv.style.backgroundPositionY = "-70px"
      document.body.appendChild(elemDiv)
    }

    var elemDiv1 = document.createElement("div")
    elemDiv1.className = "f1-effect"
    for (let i = 0; i < 30; i++) {
      let elemDiv = document.createElement("div")
      elemDiv.className = "f1-effect-flower"
      elemDiv1.appendChild(elemDiv)
    }
    document.body.appendChild(elemDiv1)

    configTheme.initFireWork()
  },
}
export default configTheme
